import { useEffect } from "react";
import CartBody from "../CartBody";
import IconBxChevronUp from "../icons/IconBxChevronUp";
import Scripts from "./Scripts";

export default function ProductListDescription({ description }: { description: string | null | undefined }) {
  useEffect(() => {
  })
  return (
    <CartBody className="mt-10 px-6 py-8">
      <div className="relative" id="mainWrapper">
        <div className="categoryDescription overflow-hidden"
          style={{
            height: '150px',
            transitionProperty: 'all',
            transitionDuration: '.5s',
            transitionTimingFunction: "linear"
          }}
        >
          {description && <div dangerouslySetInnerHTML={{
            __html: description
          }} id="contentWrapper" />}
          <div className="absolute bottom-0 left-0">
            <button className="flex items-center text-sm text-primary-500 bg-transparent border-0 outline-0" id="showMoreBtn">
              <IconBxChevronUp width={18} height={18} className="rotate-180" />
              <span>
                نمایش بیشتر
              </span>
            </button>

            <button className="flex !hidden items-center text-sm text-primary-500 bg-transparent border-0 outline-0" id="showLessBtn">
              <IconBxChevronUp width={18} height={18} />
              <span>
                نمایش کمتر
              </span>
            </button>
          </div>
        </div>
      </div>
      <Scripts />
    </CartBody>
  )
}
